import { loadStripe } from '@stripe/stripe-js/pure';

/**
 * Stripe.js for the card screen (InGo ADR 0050), loaded from js.stripe.com
 * only when a card is paid: the `pure` entry never loads it at the app's
 * start. Stripe's own fields hold the card, so its number goes from the
 * phone to Stripe and never through InGo's code.
 *
 * One load per publishable key. A load that failed (no network, js.stripe.com
 * unreachable) is forgotten, so "Try again" loads it afresh.
 */

const loads = new Map();

/** Stripe for this key; rejects when Stripe.js could not be loaded. */
export function stripeFor(publishableKey, load = loadStripe) {
  if (!loads.has(publishableKey)) {
    const loading = Promise.resolve()
      .then(() => load(publishableKey))
      .then((stripe) => {
        if (!stripe) throw new Error('Stripe.js did not load.');

        return stripe;
      })
      .catch((e) => {
        loads.delete(publishableKey);
        throw e;
      });
    loads.set(publishableKey, loading);
  }

  return loads.get(publishableKey);
}

/** Forgets every load: for tests. */
export function forgetStripeForTest() {
  loads.clear();
}
